module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp1_9005.8ebc4cd4.png";